import * as React from 'react';
import brands from '../brands';
import { ScreenBrand, ScreenBrandData, Subtract } from 'lib/types';

/** Brand data is used to populate every screen. 
 * A given screen in a given demo flow is that screen loaded
 *  with the relevant brand data as context.
 */
export const BrandContext = React.createContext(brands.df18Brunello.home);

// look at the latter half of this page for how the types work
// https://medium.com/@jrwebdev/react-higher-order-component-patterns-in-typescript-42278f7590fb

/** Interface to add a ScreenBrand to a given component */
export interface InjectedBrandProps {
	brand: ScreenBrand;
}
/** A HOC to expose the brand from the current context to your component */
const withBrand = <P extends InjectedBrandProps>(Component: React.ComponentType<P>) =>
	class Branded extends React.Component<Subtract<P, InjectedBrandProps>> {
		render () {
			return (
				<BrandContext.Consumer>
					{brand => {
						if (brand) {
							return <Component {...this.props} brand={brand} />;
						} else {
							// tslint:disable-next-line:no-console
							console.error('Brand not found!');
							return null;
						}
					}}
				</BrandContext.Consumer>
			);
		}
	};

export default withBrand;

/** All possible keys of ScreenBrand.data */
type ScreenBrandDataKeys = keyof ScreenBrandData;
/** All possible types in the ScreenBrandData object. This is not exported because components using this HOC
 * generally should specify the type of their brandData prop
 */
interface InjectedBrandDataProps {
	brandData: ScreenBrandData[ScreenBrandDataKeys];
}
/** A HOC to expose a specific key from the data object of the current brand context to your component */
export const withBrandData = <P extends InjectedBrandDataProps>
	(dataKey: ScreenBrandDataKeys, Component: React.ComponentType<P>) =>
		class BrandedWithData extends React.Component<Subtract<P, InjectedBrandDataProps>> {
			render () {
				return (
					<BrandContext.Consumer>
						{brand => {
							if (brand && brand.data && (brand.data[dataKey] !== undefined)) {
								return <Component {...this.props} brandData={brand.data[dataKey]} />;
							} else {
								// tslint:disable-next-line:no-console
								console.error(`"${dataKey}" not found in data in brand `, brand);
								return null;
							}
						}}
					</BrandContext.Consumer>
				);
			}
		};


// WEBPACK FOOTER //
// ./src/lib/withBrand.tsx